/**
 * Utility to hide road/place/POI labels on classic (non-Standard) Mapbox styles.
 * Standard styles use setConfigProperty; classic styles require per-layer visibility toggling.
 */

import type { MapboxConfig } from '@/stores/mapStore'

/**
 * Hide label layers on classic Mapbox styles (satellite-streets, streets, light, dark, etc.)
 * based on the label config flags.
 */
export function hideClassicStyleLabels(map: mapboxgl.Map, config: MapboxConfig) {
  const style = map.getStyle()
  if (!style?.layers) return

  for (const layer of style.layers) {
    const id = layer.id

    // Road / street labels
    if (!config.labels.roads && (id.includes('road-label') || id.includes('street-label'))) {
      map.setLayoutProperty(id, 'visibility', 'none')
    }

    // Place labels (city/town names)
    if (!config.labels.places && (id.includes('place-label') || id.includes('settlement'))) {
      map.setLayoutProperty(id, 'visibility', 'none')
    }

    // POI labels & icons
    if (!config.labels.poi && id.includes('poi-label')) {
      map.setLayoutProperty(id, 'visibility', 'none')
    }

    // Transit labels
    if (!config.labels.transit && (id.includes('transit') || id.includes('airport-label'))) {
      map.setLayoutProperty(id, 'visibility', 'none')
    }
  }
}
